export default class objectToFormData {
  static transform (data: object|any) {
    let newData = new FormData();
    for (const prop in data) {
      if (data.hasOwnProperty(prop) && data[prop] !== undefined) {
        let item = data[prop];

        switch (true) {
          case item === false: { item = 0; break; }
          case item === true: { item = 1; break; }
          case item === null: { item = ''; break; }
          default: break;
        }

        newData.append(prop, item);
      }
    }
    return newData;
  }
}
